// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Appointments_mainDialog__THpeV {
  width: 96vw;
  max-width: 1400px;
  height: 96vh;
}

.Appointments_tooltipIcon__0ouc3 {
  color: var(--branded-purple);
  margin-top: 10px;
}

.Appointments_tooltip__3SRfN {
  color: var(--branded-purple);
}

.Appointments_tooltip__3SRfN .p-tooltip-arrow {
  color: var(--branded-purple);
}

.Appointments_tooltip__3SRfN .p-tooltip-text {
  background-color: white;
  border-color: var(--branded-purple);
  border: 1px solid;
  color: var(--branded-purple);
}

.Appointments_tooltipIcon__0ouc3
  .p-tooltip .p-component .p-tooltip-left .p-tooltip-active {
  background-color: white;
  color: var(--branded-purple);
}

.Appointments_infoWithTooltip__MXXHu {
  display: flex;
  align-items: center;
  padding-top: 12px;
  color: var(--branded-purple);
}

.Appointments_infoWithTooltipList__dKwN9 {
  color: var(--branded-purple);
  padding-top: 10px;
}

.Appointments_contentMain__BKMx1 {
  display: flex;
  flex-direction: column;
  height: 100%;
  padding: 5px;
}

.Appointments_headerRow__P6jBU {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  gap: 10px;
  margin-top: 10px;
  margin-bottom: 20px;
}

.Appointments_mainFilter__34wKh {
  width: fit-content;
  max-width: 250px;
  min-width: 250px;
  height: 42px;
}

.Appointments_listDateFilter__4FbbY {
  width: 250px;
  height: 42px;
}

.Appointments_filterItemBorder__yQ1bl {
  border: solid 1px var(--branded-purple-border);
  border-radius: 5px;
}

.Appointments_calendarViewContainer__7pnlJ {
  display: flex;
  flex-direction: row;
  height: calc(100% - 75px);
  width: 100%;
  gap: 5px;
}

.Appointments_calendarView__RJ-F3 {
  display: flex;
  flex-direction: column;
  gap: 5px;
  width: calc(100% - 355px);
}

.Appointments_calendarViewRightPanel__HvGmf {
  overflow-y: auto;
  width: 345px;
  min-height: 528px;
  flex: 1 1;
  height: 100%;
  border: 1px solid var(--branded-purple-border);
  border-radius: 10px;
  padding: 5px;
}

.Appointments_calendar__L-eE2 {
  flex: 1 1;
  border: 0px !important
}

.Appointments_calendarLegend__5UB7W {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  gap: 20px;
  row-gap: 10px;
  border: 1px solid var(--branded-purple-border);
  border-radius: 10px;
  padding-top: 20px;
  padding-bottom: 20px;
  padding-left: 15px;
  padding-right: 15px;
  align-items: center;
}

.Appointments_calendarLegendPending__Nae4K {
  background-color: white;
  border: 2px solid var(--branded-purple-border);
  border-radius: 5px;
  width: 32px;
  min-width: 32px;
  height: 30px;
  min-height: 30px;
}

.Appointments_calendarLegendUpcoming__n6e4V {
  background-color: white;
  border: 2px solid var(--branded-purple);
  border-radius: 5px;
  width: 32px;
  min-width: 32px;
  height: 30px;
  min-height: 30px;
}

.Appointments_calendarLegendSelected__nbjXv {
  background-color: var(--branded-purple);
  border: 2px solid var(--branded-purple);
  border-radius: 5px;
  width: 32px;
  min-width: 32px;
  height: 30px;
  min-height: 30px;
}

.Appointments_calendarLegendToday__9C98M {
  background-color: #ced4da;
  border: 2px solid #ced4da;
  border-radius: 5px;
  width: 32px;
  min-width: 32px;
  height: 30px;
  min-height: 30px;
}

.Appointments_calendarLegendText__-q3M\\+ {
  font-size: 14px;
}

.Appointments_calendarDateTemplateUpcoming__Dm7W4 {
  display: flex;
  justify-content: center;
  align-items: center;
  border: 2px solid var(--branded-purple);
  width: 42px;
  height: 40px;
  border-radius: 5px;
}

.Appointments_calendarDateTemplateAvailability__hruEK {
  display: flex;
  justify-content: center;
  align-items: center;
  border: 2px solid var(--branded-purple-border);
  width: 42px;
  height: 40px;
  border-radius: 5px;
}

.Appointments_calendarDateTemplatePending__wsIPo {
  display: flex;
  justify-content: center;
  align-items: center;
  border: 2px solid var(--branded-purple-border);
  width: 42px;
  height: 40px;
  border-radius: 5px;
}

.Appointments_calendarViewApptsContainer__O8Vo2 {
  display: flex;
  flex-direction: column;
}

.Appointments_calenderListButton__lWAxt {
  width: fit-content;
  margin-top: 10px;
}

.Appointments_calendarDateGreyedOut__cCB5B {
  color: #adb5bd;
}

.Appointments_calendarViewControllers__ggOUO {
  display: flex;
  flex-direction: column;
  gap: 5px;
  color: #666666;
}

.Appointments_calendarViewAppts__BdfGu {
  display: flex;
  flex-direction: column;
  gap: 5px;
  color: #666666;
}

.Appointments_requestDialog__pg9Xq {
  width: 750px;
  height: 100%;
}

.Appointments_dangerButton__2f4y7 {
  background-color: #a91d1d;
  border: none !important;
}

.Appointments_roundedDialogButton__-HH51 {
  border-radius: 25px;
  padding-left: 20px;
  padding-right: 20px;
}

.Appointments_roundedButton__5-CiX {
  border-radius: 50%;
}

.Appointments_requestButton__GtdNU {
  height: 42px;
  text-wrap: nowrap;
  margin-left: auto;
}

.Appointments_formContainer__52icn {
  display: flex;
  flex-direction: column;
  gap: 20px;
  padding: 10px;
}

.Appointments_formContainerInner__qV4g8 {
  display: flex;
  flex-direction: column;
  gap: 20px;
  padding: 20px;
  border: 1px solid var(--branded-purple-border);
  border-radius: 10px;
}

.Appointments_formContainerFooter__jDJv8 {
  display: flex;
  justify-content: end;
  gap: 5px;
  margin-top: 10px;
}

.Appointments_formRow__-KfS\\+ {
  display: flex;
  flex-direction: row;
  gap: 10px;
}

.Appointments_formRowHalf__U2dIa {
  width: 50%;
  padding-right: 5px;
}

.Appointments_formLabel__J6W4s {
  font-weight: 600;
}

.Appointments_formField__TXlwj {
  margin-top: 5px;
}

.Appointments_formFieldDisabled__71lVR {
  background-color: #eff3f8;
}

.Appointments_sectionDivider__pB2Ec {
  border-top: 1px solid var(--branded-purple-border);
  margin-top: 10px;
  margin-bottom: 5px;
}

.Appointments_formError__6Tw1V {
  color: red;
  font-size: 13px;
  margin-top: 5px;
  padding-left: 5px;
}

.Appointments_formDescription__yjL2o {
  color: #666666;
  font-size: 14px;
}

.Appointments_formFieldBorder__5SvKL {
  border: 1px solid var(--branded-purple-border) !important;
  border-radius: 5px !important;
}

.Appointments_formFieldBorderError__xuvnN {
  border: 1px solid red !important;
  border-radius: 5px !important;
}

.Appointments_formFieldRequired__-iCdU {
  color: red;
  padding-left: 5px;
}

.Appointments_purpleText__Hh44l {
  color: var(--branded-purple);
}

.Appointments_semiboldText__kEBh9 {
  font-weight: 500;
}

.Appointments_capsText__oauod {
  text-transform: capitalize;
}

.Appointments_listViewSelect__PplgY {
  width: 350px;
  height: 42px;
  font-weight: 600;
  border: 1px solid var(--branded-purple-border);
}

.Appointments_listViewTopHR__EpUP0 {
  border-color: var(--branded-purple-border);
  margin-top: 0px;
  margin-bottom: 20px;
}

.Appointments_listViewHeader__hdnI4 {
  display: flex;
  flex-direction: row;
  gap: 10px;
}

.Appointments_listViewContent__idtPc {
  margin-top: -81px;
}

.Appointments_listViewContentEmpty__84ieC {
  margin-top: 0px;
}

.Appointments_filterGroupLabel__ZP3l6 {
  font-weight: 600;
  font-size: 16px;
  margin-left: -20px;
  margin-right: -20px;
  background-color: var(--branded-light-purple);
  padding: 8px;
  border-radius: 10px;
}

.Appointments_loadingSmallContainer__Zsf4z {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  left: 0;
  right: 0;
  margin: 0 auto;
  z-index: 1000;
  background-color: white;
  padding: 25px;
  border-radius: 10px;
  width: 300px;
  border: #667 solid 1px;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.Appointments_noDataContainer__ZlDqE {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  border: 1px solid var(--branded-purple);
  border-radius: 10px;
  padding: 20px;
}

.Appointments_noDataIcon__yrCKk {
  font-size: 30px;
  color: var(--branded-purple);
}

.Appointments_noDataTitle__H67Ph {
  font-size: 17px;
  font-weight: bold;
  color: var(--branded-purple);
  margin-top: 10px;
  text-align: center;
}

.Appointments_noDataDescr__cjPIx {
  font-size: 14px;
  color: var(--branded-purple);
  margin-top: 5px;
  text-align: center;
}

.Appointments_hiddenMobile__JM7tj {
  display: block;
  width: 100%;
}

.Appointments_viewSelectButtonTemplate__J0zP4 {
  width: 150px;
}

.Appointments_selectButtonTemplateIcon__V7-rv {
  font-size: 14px;
}

/* tablet */
@media (max-width: 1024px) {
  .Appointments_requestDialog__pg9Xq {
    width: 73vw;
  }

  .Appointments_calendarViewContainer__7pnlJ {
    flex-direction: column;
    height: auto;
  }

  .Appointments_calendarView__RJ-F3 {
    width: 100%;
  }

  .Appointments_calendarViewRightPanel__HvGmf {
    width: 100%;
    min-height: 0px;
  }

  .Appointments_viewSelectButtonTemplate__J0zP4 {
    width: fit-content;
    padding-left: 12px;
    padding-right: 5px;
  }

  .Appointments_viewSelectButtonText__nlV9v {
    display: none;
  }

  .Appointments_listViewContent__idtPc {
    margin-top: -20px;
  }

  .Appointments_listViewSelect__PplgY {
    width: 100%;
  }

  .Appointments_listDateFilter__4FbbY {
    width: 100%;
  }
}

/* mobile */
@media (max-width: 768px) {
  .Appointments_requestDialog__pg9Xq {
    width: calc(100vw - 20px);
  }

  .Appointments_formRow__-KfS\\+ {
    flex-direction: column;
    gap: 20px;
  }

  .Appointments_hiddenMobile__JM7tj {
    display: none;
  }

  .Appointments_listViewHeader__hdnI4 {
    flex-direction: column;
    gap: 10px;
  }
}

@media (max-width: 700px) {
  .Appointments_headerRow__P6jBU {
    flex-direction: column;
  }

  .Appointments_calendarLegend__5UB7W {
    flex-direction: column;
    align-items: flex-start;
  }

  .Appointments_viewSelectButton__e\\+OrL {
    .p-button {
      width: 50% !important;
    }
  }

  .Appointments_viewSelectButtonText__nlV9v {
    display: inline-block;
  }

  .Appointments_requestButton__GtdNU {
    margin-left: 0px;
  }

  .Appointments_mainFilter__34wKh {
    width: 100%;
    max-width: none;
    min-width: 0px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/styles/appointments/Appointments.module.css"],"names":[],"mappings":"AAAA;EACE,WAAW;EACX,iBAAiB;EACjB,YAAY;AACd;;AAEA;EACE,4BAA4B;EAC5B,gBAAgB;AAClB;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,uBAAuB;EACvB,mCAAmC;EACnC,iBAAiB;EACjB,4BAA4B;AAC9B;;AAEA;;EAEE,uBAAuB;EACvB,4BAA4B;AAC9B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,iBAAiB;EACjB,4BAA4B;AAC9B;;AAEA;EACE,4BAA4B;EAC5B,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,SAAS;EACT,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,YAAY;AACd;;AAEA;EACE,8CAA8C;EAC9C,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,yBAAyB;EACzB,WAAW;EACX,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,yBAAyB;AAC3B;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,iBAAiB;EACjB,SAAO;EACP,YAAY;EACZ,8CAA8C;EAC9C,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,SAAO;EACP;AACF;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,SAAS;EACT,aAAa;EACb,8CAA8C;EAC9C,mBAAmB;EACnB,iBAAiB;EACjB,oBAAoB;EACpB,kBAAkB;EAClB,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,uBAAuB;EACvB,8CAA8C;EAC9C,kBAAkB;EAClB,WAAW;EACX,eAAe;EACf,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,uBAAuB;EACvB,uCAAuC;EACvC,kBAAkB;EAClB,WAAW;EACX,eAAe;EACf,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,uCAAuC;EACvC,uCAAuC;EACvC,kBAAkB;EAClB,WAAW;EACX,eAAe;EACf,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,yBAAyB;EACzB,kBAAkB;EAClB,WAAW;EACX,eAAe;EACf,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,uCAAuC;EACvC,WAAW;EACX,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,8CAA8C;EAC9C,WAAW;EACX,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,8CAA8C;EAC9C,WAAW;EACX,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,uBAAuB;AACzB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,aAAa;AACf;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,aAAa;EACb,8CAA8C;EAC9C,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,oBAAoB;EACpB,QAAQ;EACR,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,UAAU;EACV,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,kDAAkD;EAClD,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,UAAU;EACV,eAAe;EACf,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,yDAAyD;EACzD,6BAA6B;AAC/B;;AAEA;EACE,gCAAgC;EAChC,6BAA6B;AAC/B;;AAEA;EACE,UAAU;EACV,iBAAiB;AACnB;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,YAAY;EACZ,YAAY;EACZ,gBAAgB;EAChB,8CAA8C;AAChD;;AAEA;EACE,0CAA0C;EAC1C,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,kBAAkB;EAClB,mBAAmB;EACnB,6CAA6C;EAC7C,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,2BAA2B;EAC3B,OAAO;EACP,QAAQ;EACR,cAAc;EACd,aAAa;EACb,uBAAuB;EACvB,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,sBAAsB;EACtB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,uCAAuC;EACvC,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,eAAe;EACf,4BAA4B;AAC9B;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,4BAA4B;EAC5B,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,4BAA4B;EAC5B,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,WAAW;AACb;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,eAAe;AACjB;;AAEA,WAAW;AACX;EACE;IACE,WAAW;EACb;;EAEA;IACE,sBAAsB;IACtB,YAAY;EACd;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,WAAW;IACX,eAAe;EACjB;;EAEA;IACE,kBAAkB;IAClB,kBAAkB;IAClB,kBAAkB;EACpB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,WAAW;EACb;AACF;;AAEA,WAAW;AACX;EACE;IACE,yBAAyB;EAC3B;;EAEA;IACE,sBAAsB;IACtB,SAAS;EACX;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,sBAAsB;IACtB,SAAS;EACX;AACF;;AAEA;EACE;IACE,sBAAsB;EACxB;;EAEA;IACE,sBAAsB;IACtB,uBAAuB;EACzB;;EAEA;IACE;MACE,qBAAqB;IACvB;EACF;;EAEA;IACE,qBAAqB;EACvB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,WAAW;IACX,eAAe;IACf,cAAc;EAChB;AACF","sourcesContent":[".mainDialog {\n  width: 96vw;\n  max-width: 1400px;\n  height: 96vh;\n}\n\n.tooltipIcon {\n  color: var(--branded-purple);\n  margin-top: 10px;\n}\n\n.tooltip {\n  color: var(--branded-purple);\n}\n\n.tooltip :global(.p-tooltip-arrow) {\n  color: var(--branded-purple);\n}\n\n.tooltip :global(.p-tooltip-text) {\n  background-color: white;\n  border-color: var(--branded-purple);\n  border: 1px solid;\n  color: var(--branded-purple);\n}\n\n.tooltipIcon\n  :global(.p-tooltip .p-component .p-tooltip-left .p-tooltip-active) {\n  background-color: white;\n  color: var(--branded-purple);\n}\n\n.infoWithTooltip {\n  display: flex;\n  align-items: center;\n  padding-top: 12px;\n  color: var(--branded-purple);\n}\n\n.infoWithTooltipList {\n  color: var(--branded-purple);\n  padding-top: 10px;\n}\n\n.contentMain {\n  display: flex;\n  flex-direction: column;\n  height: 100%;\n  padding: 5px;\n}\n\n.headerRow {\n  display: flex;\n  flex-direction: row;\n  flex-wrap: wrap;\n  gap: 10px;\n  margin-top: 10px;\n  margin-bottom: 20px;\n}\n\n.mainFilter {\n  width: fit-content;\n  max-width: 250px;\n  min-width: 250px;\n  height: 42px;\n}\n\n.listDateFilter {\n  width: 250px;\n  height: 42px;\n}\n\n.filterItemBorder {\n  border: solid 1px var(--branded-purple-border);\n  border-radius: 5px;\n}\n\n.calendarViewContainer {\n  display: flex;\n  flex-direction: row;\n  height: calc(100% - 75px);\n  width: 100%;\n  gap: 5px;\n}\n\n.calendarView {\n  display: flex;\n  flex-direction: column;\n  gap: 5px;\n  width: calc(100% - 355px);\n}\n\n.calendarViewRightPanel {\n  overflow-y: auto;\n  width: 345px;\n  min-height: 528px;\n  flex: 1;\n  height: 100%;\n  border: 1px solid var(--branded-purple-border);\n  border-radius: 10px;\n  padding: 5px;\n}\n\n.calendar {\n  flex: 1;\n  border: 0px !important\n}\n\n.calendarLegend {\n  display: flex;\n  flex-direction: row;\n  flex-wrap: wrap;\n  gap: 20px;\n  row-gap: 10px;\n  border: 1px solid var(--branded-purple-border);\n  border-radius: 10px;\n  padding-top: 20px;\n  padding-bottom: 20px;\n  padding-left: 15px;\n  padding-right: 15px;\n  align-items: center;\n}\n\n.calendarLegendPending {\n  background-color: white;\n  border: 2px solid var(--branded-purple-border);\n  border-radius: 5px;\n  width: 32px;\n  min-width: 32px;\n  height: 30px;\n  min-height: 30px;\n}\n\n.calendarLegendUpcoming {\n  background-color: white;\n  border: 2px solid var(--branded-purple);\n  border-radius: 5px;\n  width: 32px;\n  min-width: 32px;\n  height: 30px;\n  min-height: 30px;\n}\n\n.calendarLegendSelected {\n  background-color: var(--branded-purple);\n  border: 2px solid var(--branded-purple);\n  border-radius: 5px;\n  width: 32px;\n  min-width: 32px;\n  height: 30px;\n  min-height: 30px;\n}\n\n.calendarLegendToday {\n  background-color: #ced4da;\n  border: 2px solid #ced4da;\n  border-radius: 5px;\n  width: 32px;\n  min-width: 32px;\n  height: 30px;\n  min-height: 30px;\n}\n\n.calendarLegendText {\n  font-size: 14px;\n}\n\n.calendarDateTemplateUpcoming {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  border: 2px solid var(--branded-purple);\n  width: 42px;\n  height: 40px;\n  border-radius: 5px;\n}\n\n.calendarDateTemplateAvailability {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  border: 2px solid var(--branded-purple-border);\n  width: 42px;\n  height: 40px;\n  border-radius: 5px;\n}\n\n.calendarDateTemplatePending {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  border: 2px solid var(--branded-purple-border);\n  width: 42px;\n  height: 40px;\n  border-radius: 5px;\n}\n\n.calendarViewApptsContainer {\n  display: flex;\n  flex-direction: column;\n}\n\n.calenderListButton {\n  width: fit-content;\n  margin-top: 10px;\n}\n\n.calendarDateGreyedOut {\n  color: #adb5bd;\n}\n\n.calendarViewControllers {\n  display: flex;\n  flex-direction: column;\n  gap: 5px;\n  color: #666666;\n}\n\n.calendarViewAppts {\n  display: flex;\n  flex-direction: column;\n  gap: 5px;\n  color: #666666;\n}\n\n.requestDialog {\n  width: 750px;\n  height: 100%;\n}\n\n.dangerButton {\n  background-color: #a91d1d;\n  border: none !important;\n}\n\n.roundedDialogButton {\n  border-radius: 25px;\n  padding-left: 20px;\n  padding-right: 20px;\n}\n\n.roundedButton {\n  border-radius: 50%;\n}\n\n.requestButton {\n  height: 42px;\n  text-wrap: nowrap;\n  margin-left: auto;\n}\n\n.formContainer {\n  display: flex;\n  flex-direction: column;\n  gap: 20px;\n  padding: 10px;\n}\n\n.formContainerInner {\n  display: flex;\n  flex-direction: column;\n  gap: 20px;\n  padding: 20px;\n  border: 1px solid var(--branded-purple-border);\n  border-radius: 10px;\n}\n\n.formContainerFooter {\n  display: flex;\n  justify-content: end;\n  gap: 5px;\n  margin-top: 10px;\n}\n\n.formRow {\n  display: flex;\n  flex-direction: row;\n  gap: 10px;\n}\n\n.formRowHalf {\n  width: 50%;\n  padding-right: 5px;\n}\n\n.formLabel {\n  font-weight: 600;\n}\n\n.formField {\n  margin-top: 5px;\n}\n\n.formFieldDisabled {\n  background-color: #eff3f8;\n}\n\n.sectionDivider {\n  border-top: 1px solid var(--branded-purple-border);\n  margin-top: 10px;\n  margin-bottom: 5px;\n}\n\n.formError {\n  color: red;\n  font-size: 13px;\n  margin-top: 5px;\n  padding-left: 5px;\n}\n\n.formDescription {\n  color: #666666;\n  font-size: 14px;\n}\n\n.formFieldBorder {\n  border: 1px solid var(--branded-purple-border) !important;\n  border-radius: 5px !important;\n}\n\n.formFieldBorderError {\n  border: 1px solid red !important;\n  border-radius: 5px !important;\n}\n\n.formFieldRequired {\n  color: red;\n  padding-left: 5px;\n}\n\n.purpleText {\n  color: var(--branded-purple);\n}\n\n.semiboldText {\n  font-weight: 500;\n}\n\n.capsText {\n  text-transform: capitalize;\n}\n\n.listViewSelect {\n  width: 350px;\n  height: 42px;\n  font-weight: 600;\n  border: 1px solid var(--branded-purple-border);\n}\n\n.listViewTopHR {\n  border-color: var(--branded-purple-border);\n  margin-top: 0px;\n  margin-bottom: 20px;\n}\n\n.listViewHeader {\n  display: flex;\n  flex-direction: row;\n  gap: 10px;\n}\n\n.listViewContent {\n  margin-top: -81px;\n}\n\n.listViewContentEmpty {\n  margin-top: 0px;\n}\n\n.filterGroupLabel {\n  font-weight: 600;\n  font-size: 16px;\n  margin-left: -20px;\n  margin-right: -20px;\n  background-color: var(--branded-light-purple);\n  padding: 8px;\n  border-radius: 10px;\n}\n\n.loadingSmallContainer {\n  position: absolute;\n  top: 50%;\n  transform: translateY(-50%);\n  left: 0;\n  right: 0;\n  margin: 0 auto;\n  z-index: 1000;\n  background-color: white;\n  padding: 25px;\n  border-radius: 10px;\n  width: 300px;\n  border: #667 solid 1px;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n}\n\n.noDataContainer {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  border: 1px solid var(--branded-purple);\n  border-radius: 10px;\n  padding: 20px;\n}\n\n.noDataIcon {\n  font-size: 30px;\n  color: var(--branded-purple);\n}\n\n.noDataTitle {\n  font-size: 17px;\n  font-weight: bold;\n  color: var(--branded-purple);\n  margin-top: 10px;\n  text-align: center;\n}\n\n.noDataDescr {\n  font-size: 14px;\n  color: var(--branded-purple);\n  margin-top: 5px;\n  text-align: center;\n}\n\n.hiddenMobile {\n  display: block;\n  width: 100%;\n}\n\n.viewSelectButtonTemplate {\n  width: 150px;\n}\n\n.selectButtonTemplateIcon {\n  font-size: 14px;\n}\n\n/* tablet */\n@media (max-width: 1024px) {\n  .requestDialog {\n    width: 73vw;\n  }\n\n  .calendarViewContainer {\n    flex-direction: column;\n    height: auto;\n  }\n\n  .calendarView {\n    width: 100%;\n  }\n\n  .calendarViewRightPanel {\n    width: 100%;\n    min-height: 0px;\n  }\n\n  .viewSelectButtonTemplate {\n    width: fit-content;\n    padding-left: 12px;\n    padding-right: 5px;\n  }\n\n  .viewSelectButtonText {\n    display: none;\n  }\n\n  .listViewContent {\n    margin-top: -20px;\n  }\n\n  .listViewSelect {\n    width: 100%;\n  }\n\n  .listDateFilter {\n    width: 100%;\n  }\n}\n\n/* mobile */\n@media (max-width: 768px) {\n  .requestDialog {\n    width: calc(100vw - 20px);\n  }\n\n  .formRow {\n    flex-direction: column;\n    gap: 20px;\n  }\n\n  .hiddenMobile {\n    display: none;\n  }\n\n  .listViewHeader {\n    flex-direction: column;\n    gap: 10px;\n  }\n}\n\n@media (max-width: 700px) {\n  .headerRow {\n    flex-direction: column;\n  }\n\n  .calendarLegend {\n    flex-direction: column;\n    align-items: flex-start;\n  }\n\n  .viewSelectButton {\n    :global(.p-button) {\n      width: 50% !important;\n    }\n  }\n\n  .viewSelectButtonText {\n    display: inline-block;\n  }\n\n  .requestButton {\n    margin-left: 0px;\n  }\n\n  .mainFilter {\n    width: 100%;\n    max-width: none;\n    min-width: 0px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"mainDialog": `Appointments_mainDialog__THpeV`,
	"tooltipIcon": `Appointments_tooltipIcon__0ouc3`,
	"tooltip": `Appointments_tooltip__3SRfN`,
	"infoWithTooltip": `Appointments_infoWithTooltip__MXXHu`,
	"infoWithTooltipList": `Appointments_infoWithTooltipList__dKwN9`,
	"contentMain": `Appointments_contentMain__BKMx1`,
	"headerRow": `Appointments_headerRow__P6jBU`,
	"mainFilter": `Appointments_mainFilter__34wKh`,
	"listDateFilter": `Appointments_listDateFilter__4FbbY`,
	"filterItemBorder": `Appointments_filterItemBorder__yQ1bl`,
	"calendarViewContainer": `Appointments_calendarViewContainer__7pnlJ`,
	"calendarView": `Appointments_calendarView__RJ-F3`,
	"calendarViewRightPanel": `Appointments_calendarViewRightPanel__HvGmf`,
	"calendar": `Appointments_calendar__L-eE2`,
	"calendarLegend": `Appointments_calendarLegend__5UB7W`,
	"calendarLegendPending": `Appointments_calendarLegendPending__Nae4K`,
	"calendarLegendUpcoming": `Appointments_calendarLegendUpcoming__n6e4V`,
	"calendarLegendSelected": `Appointments_calendarLegendSelected__nbjXv`,
	"calendarLegendToday": `Appointments_calendarLegendToday__9C98M`,
	"calendarLegendText": `Appointments_calendarLegendText__-q3M+`,
	"calendarDateTemplateUpcoming": `Appointments_calendarDateTemplateUpcoming__Dm7W4`,
	"calendarDateTemplateAvailability": `Appointments_calendarDateTemplateAvailability__hruEK`,
	"calendarDateTemplatePending": `Appointments_calendarDateTemplatePending__wsIPo`,
	"calendarViewApptsContainer": `Appointments_calendarViewApptsContainer__O8Vo2`,
	"calenderListButton": `Appointments_calenderListButton__lWAxt`,
	"calendarDateGreyedOut": `Appointments_calendarDateGreyedOut__cCB5B`,
	"calendarViewControllers": `Appointments_calendarViewControllers__ggOUO`,
	"calendarViewAppts": `Appointments_calendarViewAppts__BdfGu`,
	"requestDialog": `Appointments_requestDialog__pg9Xq`,
	"dangerButton": `Appointments_dangerButton__2f4y7`,
	"roundedDialogButton": `Appointments_roundedDialogButton__-HH51`,
	"roundedButton": `Appointments_roundedButton__5-CiX`,
	"requestButton": `Appointments_requestButton__GtdNU`,
	"formContainer": `Appointments_formContainer__52icn`,
	"formContainerInner": `Appointments_formContainerInner__qV4g8`,
	"formContainerFooter": `Appointments_formContainerFooter__jDJv8`,
	"formRow": `Appointments_formRow__-KfS+`,
	"formRowHalf": `Appointments_formRowHalf__U2dIa`,
	"formLabel": `Appointments_formLabel__J6W4s`,
	"formField": `Appointments_formField__TXlwj`,
	"formFieldDisabled": `Appointments_formFieldDisabled__71lVR`,
	"sectionDivider": `Appointments_sectionDivider__pB2Ec`,
	"formError": `Appointments_formError__6Tw1V`,
	"formDescription": `Appointments_formDescription__yjL2o`,
	"formFieldBorder": `Appointments_formFieldBorder__5SvKL`,
	"formFieldBorderError": `Appointments_formFieldBorderError__xuvnN`,
	"formFieldRequired": `Appointments_formFieldRequired__-iCdU`,
	"purpleText": `Appointments_purpleText__Hh44l`,
	"semiboldText": `Appointments_semiboldText__kEBh9`,
	"capsText": `Appointments_capsText__oauod`,
	"listViewSelect": `Appointments_listViewSelect__PplgY`,
	"listViewTopHR": `Appointments_listViewTopHR__EpUP0`,
	"listViewHeader": `Appointments_listViewHeader__hdnI4`,
	"listViewContent": `Appointments_listViewContent__idtPc`,
	"listViewContentEmpty": `Appointments_listViewContentEmpty__84ieC`,
	"filterGroupLabel": `Appointments_filterGroupLabel__ZP3l6`,
	"loadingSmallContainer": `Appointments_loadingSmallContainer__Zsf4z`,
	"noDataContainer": `Appointments_noDataContainer__ZlDqE`,
	"noDataIcon": `Appointments_noDataIcon__yrCKk`,
	"noDataTitle": `Appointments_noDataTitle__H67Ph`,
	"noDataDescr": `Appointments_noDataDescr__cjPIx`,
	"hiddenMobile": `Appointments_hiddenMobile__JM7tj`,
	"viewSelectButtonTemplate": `Appointments_viewSelectButtonTemplate__J0zP4`,
	"selectButtonTemplateIcon": `Appointments_selectButtonTemplateIcon__V7-rv`,
	"viewSelectButtonText": `Appointments_viewSelectButtonText__nlV9v`,
	"viewSelectButton": `Appointments_viewSelectButton__e+OrL`
};
export default ___CSS_LOADER_EXPORT___;
